module.exports = __webpack_public_path__ + "media/images/Turquoise-b729b700.jpg";